/* eslint-disable max-len */
import { Box, chakra, HStack } from '@chakra-ui/react';
import React, { PropsWithChildren, ElementType } from 'react';

import { RippleButton, RippleButtonProps } from '../ripple-button';

type Props = PropsWithChildren<{
    onClose: () => any
    Icon?: ElementType | null
    borderColor?: string
}>;

export function ToastView ({
    children, onClose, Icon, borderColor = 'neutral.200'
}: Props) {
    return (
        <HStack
            data-testid={'toast-view'}
            spacing={'8px'}
            p={{
                base: '14px',
                medium: '24px'
            }}
            border={'1px solid'}
            borderColor={borderColor}
            borderRadius={'12px'}
            boxShadow={'0px 2px 20px rgba(0, 25, 55, 0.08)'}
            color={'neutral.700'}
            letterSpacing={'-0.1px'}
            fontWeight={'400'}
            fontSize={{
                mobile: '14px',
                tablet: '16px'
            }}
            minW={{
                base: '100%',
                large: '548px'
            }}
            maxW={'548px'}
            w={'100%'}
            alignItems={'flex-start'}
            justifyContent={'space-between'}
            background={'white'}
        >
            <HStack
                alignItems={'flex-start'}
            >
                {Icon && <Icon />}

                <Box>
                    {children}
                </Box>
            </HStack>

            <CloseButton onClick={onClose} />
        </HStack>
    );
}

function CloseButton (props: RippleButtonProps) {
    return (
        <RippleButton variant={'unstyled'} minWidth={'24px'} width="24px" height="24px" {...props}>
            <chakra.svg minWidth={'24px'} width="24px" height="24px" viewBox="0 0 25 25" fill="none">
                <path
                    d="M5.52678 5.82005C5.93556 5.40206 6.60794 5.39268 7.02859 5.79908L11.9285 10.5331L16.6778 5.67684C17.1207 5.22403 17.8491 5.21386 18.3048 5.65413V5.65413C18.7605 6.0944 18.7709 6.81839 18.3281 7.27121L13.5788 12.1275L18.4534 16.837C18.874 17.2434 18.8836 17.9117 18.4749 18.3297V18.3297C18.0661 18.7477 17.3937 18.7571 16.9731 18.3507L12.0985 13.6411L7.3492 18.4974C6.90636 18.9502 6.17795 18.9604 5.72225 18.5201V18.5201C5.26655 18.0799 5.25612 17.3559 5.69895 16.9031L10.4482 12.0468L5.54829 7.31273C5.12764 6.90633 5.11801 6.23803 5.52678 5.82005V5.82005Z"
                    fill="#001937"
                />
            </chakra.svg>
        </RippleButton>
    );
}
